import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getPetitionSettingsPageData } from './api/getPetitionSettingsPageData';

export const {
	Context: PetitionSettingsPageDataContext,
	Provider: PetitionSettingsPageDataContextProvider,
	useContext: usePetitionSettingsPageData,
	useAsyncData: usePetitionSettingsPageDataFromApi,
	prefetchAsyncData: prefetchPetitionSettingsPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PetitionSettingsPageDataContext',
	dataProperty: 'pageSettingsData',
	getData: getPetitionSettingsPageData,
	hookDeps: ({ slugOrId }) => [slugOrId],
	getUniqueId: ({ slugOrId }) => slugOrId,
	errorHandler: pageDataErrorHandler(),
});
